import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { SharedModule } from '../shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ServicesRoutingModule } from './services-routing.module';

import {PanelModule} from 'primeng/panel';
import {CardModule} from 'primeng/card';
import {InputTextModule} from 'primeng/inputtext';
import {DialogModule} from 'primeng/dialog';
import {ButtonModule} from 'primeng/button';
import {TooltipModule} from 'primeng/tooltip';

import { AvailableServicesComponent } from './components/available-services/available-services.component';
import { MyServicesComponent } from './components/my-services/my-services.component';
import { DataTableModule } from '@pascalhonegger/ng-datatable';
import { NbImplementationModule } from '../nb-implementation.module';

@NgModule({
  declarations: [
    MyServicesComponent,
    AvailableServicesComponent,
  ],
  imports: [
    CommonModule,
    ServicesRoutingModule,
    SharedModule,
    TranslateModule,

    PanelModule,
    CardModule,
    InputTextModule,
    DialogModule,
    ButtonModule,
    TooltipModule,
    DataTableModule,
    NbImplementationModule
  ],
})
export class ServicesModule { }
